import SafeRenderHtml from 'CampaignVolunteer/components/SafeRenderHtml'

export default function DashboardInstructions({ onClose }) {
  const instructions = useSel(s => s.dashboard.instructions)

  return <div className="instructions">
    <div className="instructions-header">
      <div className="icon"><SvgIconsTipInGreyBox /></div>
      <div className="instructions-title">
        <h1 className="no-margin">Need help?</h1>
        <p className="no-margin-bottom margin-top half">For an explanation of this page and help using it, please read the instructions here.</p>
      </div>
      <div className="close-button" onClick={() => onClose(false)}>
        <SvgIconsClose />
      </div>
    </div>

    <div className="instructions-body">
      <div className="content">
        <SafeRenderHtml html={instructions} />
      </div>
    </div>
  </div>
}
